import Geosuggest, { GeosuggestSkeleton, strings } from "./Geosuggest"

export default Geosuggest
export { Geosuggest, GeosuggestSkeleton, strings }
